import { Component, OnInit } from '@angular/core';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {MatChipInputEvent} from '@angular/material/chips';
import {ApiService, PropertyType, Software, SoftwareProperty, SoftwaresList} from '../../api/api.service';
import {TranslateService} from '@ngx-translate/core';
import {MatDialogRef} from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';

@Component({
  selector: 'app-create-software-dialog',
  templateUrl: './create-software-dialog.component.html',
  styleUrls: ['./create-software-dialog.component.css']
})
export class CreateSoftwareDialogComponent implements OnInit {

  softwares: SoftwaresList;
  loaded = false;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  canAdd = false;
  software: Software = {
    versions:'1.0',
    software_name: '',
    description: '',
    short_description:'',
    price: '',
    telegram_bot_token:'',
    approved: false,
    email:'',
    billingPeriod:'1m'
  };

  options: string[] = ['int', 'long', 'float', 'string', 'boolean'];
  propOption = 'string';
  optionsList: SoftwareProperty[] = [];

  constructor(
    public dialogRef: MatDialogRef<CreateSoftwareDialogComponent>,
    private api: ApiService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.api.getSoftwaresList().subscribe(response => {
      this.softwares = response;
      this.loaded = true;
    });
    this.optionsList.push({
      name: 'symbols_to_watch_0645',
      value: 'AUDCAD,AUDCHF,AUDJPY,AUDNZD,AUDUSD,CADCHF,CADJPY,CHFJPY,' +
        'EURAUD,EURCAD,EURCHF,EURGBP,EURJPY,EURNZD,EURUSD,GBPCHF,GBPJPY,' +
        'GBPUSD,NZDJPY,NZDUSD,USDCAD,USDCHF,USDJPY',
      type: PropertyType.string
    })
  }

  addOption(name:string, type:string, value:string) {
    if (name.length > 0 && value.length > 0) {
      let finded = false;
      for (let item of this.optionsList)
        if (item.name == name)
          finded = true;
      if (!finded) {
        let typeEn: PropertyType;
        switch (type) {
          case 'int':
            typeEn = PropertyType.int;
            break;
          case 'float':
            typeEn = PropertyType.float;
            break;
          case 'long':
            typeEn = PropertyType.long;
            break;
          case 'string':
            typeEn = PropertyType.string;
            break;
          case 'boolean':
            typeEn = PropertyType.boolean;
            break;
        }
        this.optionsList.push({
          name: name,
          value: value,
          type: typeEn
        })
      }
    }
    this.software.properties = this.optionsList;
  }

  removeOption(name:string) {
    this.optionsList.forEach(option => {
      if (option.name == name)
        this.optionsList.splice(this.optionsList.indexOf(option),1)
    });
    this.software.properties = this.optionsList;
  }

  removeVersion(version: string) {
    const versions = this.software.versions.split(",");
    let result = "";
    versions.forEach(vers => {
      if (vers != version && vers != "")
        result+=vers+",";
    });
    if(result.length > 0)
      result = result.substr(0, result.length-1);
    this.software.versions = result;
    this.canAdd = this.checkForAdd();
  }

  getVersionsArray(): string[] {
    if (this.software!=undefined) {
      let versionsRet = this.software.versions.split(",");
      const nulRet = [];
      if (versionsRet[0] == "" && versionsRet.length == 1)
        return nulRet;
      return versionsRet
    }
    return [];
  }

  addVersion(event: MatChipInputEvent) {
    const input = event.input;
    const value = event.value;

    const versions = this.software.versions.split(",");
    if (versions.indexOf(value.trim()) >= 0 || value.trim() == "") {
      if(value.trim() != "")
        this.openSnackBar(this.translateService.instant('partner-manager.create-software-dialog.snackbar-1'))
    } else {
      if ((value || '').trim()) {
        versions.push(value.trim());
        let result = '';
        versions.forEach(vers => {
          if (vers != "")
            result += vers+',';
        });
        if(result.length > 0)
          result = result.substr(0, result.length-1);
        console.log(result);
        this.software.versions = result;
      }
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.canAdd = this.checkForAdd();
  }

  nameChanges(name: HTMLInputElement) {
    this.software.software_name = name.value;
    this.canAdd = this.checkForAdd();
  }

  priceChanges(price: HTMLInputElement) {
    this.software.price = price.value.replace(",",".");
    this.canAdd = this.checkForAdd();
  }

  shDescrChanges(box: HTMLInputElement) {
    this.software.short_description = btoa(box.value);
    this.canAdd = this.checkForAdd();
  }

  descrChanges(box) {
    this.software.description = btoa(box.value);
    this.canAdd = this.checkForAdd();
  }

  openSnackBar(message: string) {
    let config = new MatSnackBarConfig();
    config.verticalPosition = 'bottom';
    config.horizontalPosition = 'center';
    config.duration = 5000;
    this.snackBar.open(message, this.translateService.instant('login.snackbar-action-1'), config);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  checkForAdd() {
    if (this.software.software_name.length <= 0)
      return false;
    if (this.checkIfSoftwareExists(this.software.software_name)) {
      this.openSnackBar("Nome già esistente");
      return false;
    }
    if (this.software.price.length <= 0) {
      return false;
    }
    if (this.software.versions.length <= 0)
      return false;
    if (this.software.description.length <= 0 || this.software.short_description.length <= 0)
      return false;
    this.software.software_name = this.software.software_name.toLocaleLowerCase();
    return true;
  }

  checkIfSoftwareExists(softwareName: string) {
    softwareName = String(softwareName).toLowerCase();
    let finded = false;
    this.softwares.softwares.forEach(soft => {
      if (soft.software_name.toLowerCase() == softwareName)
        finded = true
    });
    return finded && this.loaded
  }
}
